import { Injectable } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  SurveyTriggerService,
  SurveyTriggerContext,
} from 'src/app/@shared/survey/survey-trigger.service';

@Injectable({ providedIn: 'root' })
export class PlannerSurveyOrchestratorService {
  private readonly _displaySurveyId$ = new BehaviorSubject<number | null>(null);
  readonly displaySurveyId$ = this._displaySurveyId$.asObservable();

  private surveyTimer: ReturnType<typeof setTimeout> | null = null;
  private pendingSub: Subscription | null = null;

  constructor(private readonly surveyTriggerService: SurveyTriggerService) {}

  /** Call when app language changes: drop cache and hide pending/active survey. */
  onLanguageChanged(): void {
    this.cancelScheduledSurvey();
    this._displaySurveyId$.next(null);
    this.surveyTriggerService.clearCache();
  }

  cancelScheduledSurvey(): void {
    if (this.surveyTimer) {
      clearTimeout(this.surveyTimer);
      this.surveyTimer = null;
    }
    this.pendingSub?.unsubscribe();
    this.pendingSub = null;
  }

  onSurveyUiClosed(): void {
    this._displaySurveyId$.next(null);
  }

  /**
   * After a successful planner search: resolve CMS triggers, then show first survey after delay.
   */
  scheduleSurveyAfterSearch(context: SurveyTriggerContext): void {
    this.cancelScheduledSurvey();

    this.pendingSub = this.surveyTriggerService.getSurveysForContext(context).subscribe({
      next: (surveys) => {
        this.pendingSub = null;
        if (!surveys.length) {
          return;
        }
        const surveyId = surveys[0].id;
        const delayMs = environment.surveyDelaySeconds * 1000;
        this.surveyTimer = setTimeout(() => {
          this.surveyTimer = null;
          this._displaySurveyId$.next(surveyId);
        }, delayMs);
      },
      error: (err) => console.error('Survey trigger check failed:', err),
    });
  }
}
